// extracted by mini-css-extract-plugin
module.exports = {"container":"DTICalculator_container__Qg0Vh","wider-container":"DTICalculator_wider-container__u3Uxf","box-form":"DTICalculator_box-form__xcPfQ"};